import React from 'react'
import { Div, H3 } from 'konsys-ui'
import {
  NotchDiv, ContentContainer, ContainerIcon,
  TitleWrapper,
} from './styled'


const NotchedContainer = ({
  title = 'Title here',
  titleIcon = '',
  children,
  noTitle,
}) => (<Div>
  <Div display='flex'>
    { noTitle || <NotchDiv>
        <TitleWrapper>
          {/* <Div margin='5px' moreStyle={{ background: 'yellow', width: '30px', height: '30px' }}>
          </Div> */}
          <ContainerIcon img={titleIcon} />
          {title}
        </TitleWrapper>
      </NotchDiv>
    }
  </Div>
  <ContentContainer noTitle={noTitle}>{children}</ContentContainer>
</Div>)

export default NotchedContainer



// WEBPACK FOOTER //
// ./src/components/common/notched-containner/index.jsx